import DeleteMemberSeniorityModal from './DeleteMemberSeniorityModal.component';

export default DeleteMemberSeniorityModal;
